import React from 'react';
import { useFetchNoUser } from '../hooks/useFetchNoUser';
import DataGridView from './DataGridView';
import {
  Container,
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  BottomNavigation,
} from '@mui/material';
import { useState, useEffect } from 'react';
import format from 'date-fns/format';
function ViewSessionDates({ catId }) {
  const [tableData, setTableData] = useState([]);
  const { error, errorMessage, isPending, data } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/sessioninfo',
  );

  useEffect(
    (tableData) => {
      if (data) {
        setTableData(data);
      }
    },
    [data],
  );

  const columns = [
    { field: 'academicYear', headerName: 'Year:', width: 100 },
    { field: 'session', headerName: 'Session:', width: 120 },
    { field: 'qualification', headerName: 'Qualification:', width: 150 },

    {
      field: 'startDate',
      headerName: 'Start Date:',
      width: 120,
      valueFormatter: (params) => {
        return format(new Date(params.value), 'yyyy/MM/dd');
      },
    },
    {
      field: 'stage1Date',
      headerName: 'Stage 1 Penalty:',
      width: 120,
      valueFormatter: (params) => {
        return format(new Date(params.value), 'yyyy/MM/dd');
      },
    },
    {
      field: 'stage2Date',
      headerName: 'Stage 2 Penalty:',
      width: 120,
      valueFormatter: (params) => {
        return format(new Date(params.value), 'yyyy/MM/dd');
      },
    },
    {
      field: 'stage3Date',
      headerName: 'Stage 3 Penalty:',
      width: 120,
      valueFormatter: (params) => {
        return format(new Date(params.value), 'yyyy/MM/dd');
      },
    },
    {
      field: 'endDate',
      headerName: 'End Date:',
      width: 120,
      valueFormatter: (params) => {
        return format(new Date(params.value), 'yyyy/MM/dd');
      },
    },
  ];

  return (
    <>
      {isPending && !error && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography variant="h6" component="h3" color="primary">
            Fetching course fees ........
          </Typography>
        </Box>
      )}

      {error && !errorMessage && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography variant="h6" component="h3" color="error">
            Unable to fetch coourse fee list. You may be offline. Please try
            again.
          </Typography>
        </Box>
      )}
      {errorMessage && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography variant="h6" component="h3" color="error">
            {errorMessage}
          </Typography>
        </Box>
      )}
      {!isPending && !error && tableData.length > 0 && (
        <DataGridView
          tableData={tableData}
          error={error}
          isPending={isPending}
          getFormattedDate={null}
          columns={columns}
          pageSize={tableData.length}
          handleOnCellClick={null}
          getRowId={(row) => row.id}
          disableRowSelectionOnClick
          hideMenu
          hideFooterPagination={true}
          hideFooter={true}
          showCellRightBorder={true}
          showColumnRightBorder={true}
          hideScrollbar={true}
        />
      )}
      {!isPending && !error && tableData.length === 0 && (
        <Typography
          variant="body2"
          component="p"
          color="primary.main"
          sx={{ textAlign: 'center' }}
        >
          <b>
            There are currently no active Cambridge Examination sessions for
            entry.
          </b>
        </Typography>
      )}
    </>
  );
}

export default ViewSessionDates;
